import { ScrapbookFile } from '@/api/scrapbook-data';
import ContentPreviewWraper from './ContentPreviewWraper';
import StatBankItem from '@/components/statbank/StatBankItem';
import { Link } from '@/components';

interface StatPreviewProps {
  content: ScrapbookFile | null;
  onClose: () => void;
}
const StatPreview = ({ content, onClose }: StatPreviewProps) => {
  const onCopy = async () => {
    const textToCopy = `${content?.content.numericValue}\n${content?.content.description}`;
    const formattedHtmlContent = `<b>${content?.content.numericValue}</b><br>${content?.content.description}`;
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([formattedHtmlContent], { type: 'text/html' }),
        'text/plain': new Blob([textToCopy], { type: 'text/plain' }),
      }),
    ]);
  };
  return (
    <ContentPreviewWraper
      content={content}
      onClose={onClose}
      title="Stat"
      subTitle={content?.content?.pageTitle}
      onCopy={onCopy}
    >
      <div className="px-10">
        <StatBankItem
          data={{
            statId: '1',
            number: content?.content?.numericValue,
            description: content?.content?.description,
            statLink: content?.content?.link,
          }}
          className="py-6 [&_.description]:flex-1 [&_.description]:text-lg [&_.number]:text-5xl [&_.number-wrapper]:w-auto [&_.number-wrapper]:pr-10"
        />
        <hr className="h-px border-0 bg-black/10" />
        <div className="p-6 pt-4 text-center">
          <span>Source: </span>
          <Link link={content?.content?.link} className="text-sm text-black underline">
            {content?.content?.link?.text || content?.content?.link?.href}
          </Link>
        </div>
      </div>
    </ContentPreviewWraper>
  );
};

export default StatPreview;
